import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";

import { View, useAnimations, useGLTF } from "@react-three/drei";
import { Environment, GizmoHelper, GizmoViewport } from "@react-three/drei";
import { Gltf } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

import ThirdPersonController from "./ThirdPersonController";

const initialScale = [0.13, 0.13, 0.13];
const initialPosition = [0, -1.7, 0];
const ViewContent = ({ s_hoverPlant }) => {
  const gltfRef = useRef();
  const { animations, scene } = useGLTF(
    "https://mom.satdg.com/3D_models/SAT_official_web/2dWorldMap/scene.gltf",
  );
  const { actions } = useAnimations(animations, gltfRef);

  const [scale, setScale] = useState(initialScale);
  const [position, setPosition] = useState(initialPosition);

  useEffect(() => {
    // console.log(actions);
    // console.log(scene);
    // actions["GuangZhouAction"].play();
  }, [actions]);

  const resetAllActions = () => {
    Object.values(actions).forEach((action) => {
      action.reset();
      action.stop && action.stop();
    });
  };

  useEffect(() => {
    console.log(s_hoverPlant);
    console.log("scene = ", scene);
    console.log("actions = ", actions);
    // return;
    if (s_hoverPlant === "") {
      resetAllActions();
      // setScale(initialScale);
      // setPosition(initialPosition);
    }
    if (s_hoverPlant === "蘇州廠" || s_hoverPlant === "鴻嘉駿") {
      resetAllActions();
      actions["蘇州廠Action"]?.play();
      actions["蘇州廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["蘇州廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-18, -3.3, 0]);
    }
    if (s_hoverPlant === "福州廠") {
      resetAllActions();
      actions["福州廠Action"]?.play();
      actions["福州廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["福州廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-18, -1.3, 0]);
    }
    if (s_hoverPlant === "信鋐") {
      resetAllActions();
      actions["信鋐Action"]?.play();
      actions["信鋐Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["信鋐Action"].clampWhenFinished = true;
      setScale([1.2, 1.2, 1.2]);
      setPosition([-23, -2.5, 2]);
    }
    if (s_hoverPlant === "敬得") {
      resetAllActions();
      actions["敬得Action"]?.play();
      actions["敬得Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["敬得Action"].clampWhenFinished = true;
      setScale([1.2, 1.2, 1.2]);
      setPosition([-23, -2.5, 2]);
    }
    if (s_hoverPlant === "中山廠") {
      resetAllActions();
      actions["中山廠Action"]?.play();
      actions["中山廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["中山廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-18, -1.3, 1.5]);
    }
    if (s_hoverPlant === "冠皇") {
      resetAllActions();
      actions["冠皇Action"]?.play();
      actions["冠皇Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["冠皇Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-18, -1.3, 1.5]);
    }
    if (s_hoverPlant === "重慶廠") {
      resetAllActions();
      actions["重慶廠Action"]?.play();
      actions["重慶廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["重慶廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-17, -3, 2.5]);
    }
    if (s_hoverPlant === "泰國廠") {
      resetAllActions();
      actions["泰國廠Action"]?.play();
      actions["泰國廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["泰國廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-16, 0, 0]);
    }
    if (s_hoverPlant === "越南廠") {
      resetAllActions();
      actions["越南廠Action"]?.play();
      actions["越南廠Action"]?.setLoop(THREE.LoopOnce, 1);
      actions["越南廠Action"].clampWhenFinished = true;
      setScale([1, 1, 1]);
      setPosition([-16, 0, 0]);
    }
  }, [s_hoverPlant]);

  // useFrame(() => {
  //   if (gltfRef.current) {
  //     // position
  //     gltfRef.current.position.lerp(
  //       new THREE.Vector3(...position),
  //       0.05, // 越大越快，建議 0.05~0.2
  //     );
  //     // scale
  //     gltfRef.current.scale.lerp(new THREE.Vector3(...scale), 0.05);
  //   }
  // });

  return (
    <>
      {/*光源*/}
      <ambientLight intensity={1} />
      <directionalLight castShadow intensity={1} position={[0, 0, 100]} />
      {/*環境貼圖------------------------------->關鍵: 將自動套用到3D物件的envMap上，尤其使金屬光澤正常呈現，避免光線全吸收後模型變成黑色*/}
      <Environment files="https://mom.satdg.com/3D_images/environment/empty_warehouse_01_1k.exr" />
      <Gltf
        ref={gltfRef}
        src="https://mom.satdg.com/3D_models/SAT_official_web/2dWorldMap/scene.gltf"
        // position={position}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[4.5, 3, 3]}
        // scale={scale}
      />
      <ThirdPersonController
        orbitTarget={new THREE.Vector3(0, 0, 0)}
        cameraPosition={new THREE.Vector3(0, 0, 0)}
        enableAnimation={false}
        lockedOrbit={true}
      />

      {/* <GizmoHelper
        alignment="bottom-right" // 在畫布上的位置
        margin={[80, 80]} // 距離畫布邊緣
      >
        <GizmoViewport axisColors={["red", "green", "blue"]} labelColor="white" />
      </GizmoHelper> */}
      {/* <OrbitControls target={camTarget} /> */}
      {/*相機*/}
      {/* <PerspectiveCamera
          ref={cameraRef}
          fov={60}
          near={0.1}
          far={2000}
          makeDefault
          position={camPos}
        /> */}
      {/* <OrbitControls
          ref={orbitControlsRef}
          onStart={cancelAnimate}
          enableRotate={true}
          makeDefault
          target={camTarget}
          minDistance={5} // 設置最小縮放距離
          maxDistance={200} // 設置最大縮放距離
        /> */}
    </>
  );
};

export default ViewContent;
